module.exports = __webpack_public_path__ + "assets/f8ae94518910e35818cf186bfb707ff3.mp3";